import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterDataAPIv1 } from "./../../services/CRUDServices";

export const addressCorrectionData: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "addressCorrectionList",
  async (body: any) => {
    let { data } = await filterDataAPIv1(
      '/customer-api/address/s01/v1/addressCorrectionDataFilter',
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      body.pageNumber,
    );

    return data.response
    ;
  }
);

const initialState: any = {
  addressCorrectionList: [],
  fetchPost: false,
  errorMessage: null,
  filter: {},
};

const AddressCorrectionList = createSlice({
  initialState: initialState,
  name: "addressCorrectionList",
  reducers: {
    clearAddressCorrection: (state) => {
      // state.addressCorrectionList = [];
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [addressCorrectionData.fulfilled as any]: (state, action) => {
      state.addressCorrectionList = action.payload;
      state.fetchPost = false;
    },
    [addressCorrectionData.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [addressCorrectionData.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilter, clearAddressCorrection } =
  AddressCorrectionList.actions;
export default AddressCorrectionList.reducer;
